import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { CART_BASE } from 'bento-ordering/cart/constants/paths';
import { isMobileMedia } from 'bento-ordering/utils/media';
import MenuUpsellItemDescriptionRoute from 'bento-ordering/cart/containers/MenuUpsellItemDescriptionRoute';

const MenuItemUpsellDescriptionContainer = ({ match }) => {
  if (isMobileMedia()) {
    return <MenuUpsellItemDescriptionRoute match={match} />;
  }
  return <Redirect to={CART_BASE} />;
};

MenuItemUpsellDescriptionContainer.propTypes = {
  match: PropTypes.object.isRequired
};

export default MenuItemUpsellDescriptionContainer;
